<template>
    <span v-html="value"/>
</template>

<script>
export default {
    name: "TableCellTypeTextarea",
    props: {
        value: String,
    }
}
</script>

<style scoped>

</style>